
import Main from "components/Main";

import Table from "components/Table";
import ToggleSwitch from "components/ToggleSwitch";
import Button from "components/Button";
import ButtonIconSelect from "components/ButtonIconSelect";

import './themes/default.less';

export default class InvoiceListPreliminary extends Main {
    constructor(props) {
        super(props);

        this.actionsItems = [
            { name: "invoice.createBillCopy", onClick: this.openInvoiceOnPriorEditor.bind(this) },
            { name: "main.edit", onClick: this.props.openInvoiceEditor.bind(this) },
            { name: "invoice.cancel", onClick: this.props.removeInvoice.bind(this) },
            { line: true },
            { name: "main.print", onClick: this.props.printInvoice.bind(this, "Preordered_invoice_final") },
        ];

        this.openIcon = {
            type: "icon",
            name: "arrowDown",
            hideLabel: true,
            cantSort: true,
            size: "32px",
            typeIcon: "stroke",
            click: this.openDetailDialog.bind(this)
        };

        this.tableMap = {
            check: {
                type: "check",
                click: this.clickCheck.bind(this),
                showNo: [{ key: "status", or: (a, b) => a === b, value: "PRE_CANCELLED" }],
                cantSort: true,
                size: "16px",
            },
            openIcon: this.openIcon,
            createdTime: {
                label: "client.date",
                type: "dateTime",
                useTz: true,
            },
            invoiceNumber: {
                label: "invoice.billNumber",
                /*type: "object",
                valueFormat: "${invoiceId}/${clientId}",*/
                callback: this.formNumber.bind(this),
            },
            treatmentTask: {
                label: "main.stage",
                callback: this.stageCell.bind(this),
                cantSort: true,
            },
            teeth: {
                label: "client.teeth",
                type: "teeth",
                cantSort: true,
            },
            domainId: {
                label: "login.clinic",
                type: "select",
                store: "clinics",
                nameKey: "name",
            },
            totalSum: {
                label: "main.sum",
                type: "sum",
            },
            //paidSum: {
            invoicesPaidSum: {
                label: "invoice.sentForPayment",
                type: "sum",
            },
            actions: {
                label: "main.actions",
                type: "actions",
                callback: this.renderInCell2.bind(this),
                hideLabel: true,
                cantSort: true,
                size: "32px",
            },
            /*actions: this.actionsProps,*/
        };

        this.tableRowProps = {
            useIds: true,
            format: this.rowFormat.bind(this),
        };

        this.state = {
            ...this.state,
            sort: "-createdTime",
            items: [],
            showCanceled: true,
            checkBoxes: {},
            formExpande: false,
        };

        const { treatmentDirection, treatmentWorkStatus } = this._config;

        this.treatmentDirection = treatmentDirection;
        this.treatmentWorkStatus = treatmentWorkStatus;

        this.isPerMode = true;

        this.useTooltip = true;
        this.savedScrollPosition = null;

        this.textGroup = "Вы выбрали предварительные счета";
    }

    get actionsProps() {
        return {
            label: "main.actions",
            type: "actions",
            items: this.actionsItems,
            hideLabel: true,
            cantSort: true,
            size: "32px",
        };
    }

    componentDidUpdate() {
        super.componentDidUpdate();
        if (this.table?.domNode && this.savedScrollPosition !== null) {
            this.table.domNode.scrollTop = this.savedScrollPosition;
            this.savedScrollPosition = null;
        }
    }

    printPreAct(info) {
        this._print.preAct(info);
    }

    renderInCell2(value, map, info) {
        let actionsItems = [];
        const { domainId, comment, id, clientId, createdTime, doctorId, paidSum } = info;

        const title = `${id}/${clientId} от ${this._helper.date.toStr(new Date(createdTime), "DD.MM.YYYY")}`;
        const fio = this._helper.string.formatFullName(this.props.info);
        const doctor = this._helper.string.formatFullName(this.props.getDoctorById(doctorId));
        const clinics = this._helper.getClinics();
        const clinic = clinics.find(infoClinic => infoClinic.id === domainId);
        const { profileNumber, createdTime: dateRegistration, clientBalance, birthday, totalSum: ts, totalPaidSum } = this.props.info;
        const debt = ts - totalPaidSum;
        const infoPrint = {
            ...info, profileNumber, dateRegistration, clientBalance, birthday, ts, totalPaidSum, clinic, comment,
            fio, doctor, title, debt, paidSum, createdTime
        };

        if (info?.status !== "PRE_CANCELLED") {
            actionsItems = [
                { name: "invoice.createBillCopy", onClick: this.openInvoiceOnPriorEditor.bind(this, info) },
                { name: "main.edit", onClick: this.props.openInvoiceEditor.bind(this, info) },
                { name: "invoice.cancel", onClick: this.props.removeInvoice.bind(this, info) },
                { line: true },
                /*{ name: "main.print", onClick: this.props.printInvoice.bind(this, "Preordered_invoice_final", info) },*/
                { name: "main.print", onClick: this.printPreAct.bind(this, infoPrint) },
            ];
        }

        return (actionsItems?.length ? <ButtonIconSelect
            translate={true}
            items={actionsItems}
        /> : false);
    }

    printSelectedInvoice(listInv) {
        this._print.selectedInvoice(listInv);
    }

    getItems(n1, n2, n3) {
        return [];
    }

    formNumber(value, it, { id, clientId }) {
        return `${id}/${clientId}`;
    }

    stageCell(value) {
        const { title, treatmentDirectionId, workStatus } = value || {};

        const directItem = this.treatmentDirection.find(it => it.id === treatmentDirectionId);
        const direct = this.tr(directItem?.name || "main.notIndicated");

        const statusItem = this.treatmentWorkStatus.find(it => it.id === workStatus);
        const status = this.tr(statusItem?.name || "main.notIndicated");

        return (
            <>
                <div>{title}</div>
                <div className="second">{direct} / {status}</div>
            </>
        );
    }

    rowFormat({ status }, cl) {
        //if (status === "PRE_DELETED" || status === "REJECTED")
        if (status === "PRE_CANCELLED" || status === "CANCELLED")
            cl.push("disabled");

        return cl;
    }

    componentDidMount() {
        this.refresh();
    }

    openInvoiceOnPriorEditor(data) {
        const info = { ...data };
        info.parentInvoiceId = info.id;

        delete info.id;

        this.props.openInvoiceEditor(info);
    }

    async openDetailDialog(info) {
        const { id, clientId } = info;
        this._helper.showLoading();
        const resp = await this._request.invoices.getDetails(id);
        this._helper.hideLoading();

        resp.data.invoiceNumber = { clientId, invoiceId: id };
        resp.data.fio = this._helper.string.formatFullName(this.props.info);

        if (resp?.data)
            this._helper.openDialog("invoiceDetailDialog", resp.data, this.props.changeTab);
    }

    clickCheck(src, val, info) {


        const { checkBoxes } = this.state;
        this.savedScrollPosition = this.table?.domNode?.scrollTop || 0;

        const cb = { ...checkBoxes };
        if (src === "checkBoxMain") {
            Object.keys(this.table).forEach(it => {
                if (it.includes("checkBox") && it !== "checkBoxMain" && info?.status !== "PRE_CANCELLED")
                    cb[it] = val;
            });

            this.setState({ checkBoxes: cb });
        } else if (info?.status !== "PRE_CANCELLED") {
            this.setState({ checkBoxes: { ...checkBoxes, [src]: val } });
        }

        if (this.table?.domNode)
            this.table.domNode.scrollTop = this.savedScrollPosition;
    }

    onSortChange(sort) {
        this.state.sort = sort;
        this.refresh();
    }

    toggleCanceled() {
        this.state.showCanceled = !this.state.showCanceled;

        this.refresh();
    }

    refresh() {
        this.getData();
    }

    getTitleStage(it, arr) {

        let titleStage = "";
        const parent = arr.find(row => row.id === it.parentInvoiceId);
        if (parent)
            titleStage = parent.treatmentTask?.title;

        return titleStage;
    }

    async getData() {
        this._helper.showLoading();

        const { id } = this.props.info;
        const { sort, showCanceled } = this.state;

        const resp = await this._request.invoices.getAllForClient(id, this.isPerMode, showCanceled, sort);
        if (this.isPerMode) {
            const items = resp?.data || [];
            this.setState({ items }, this.checkScrollToItem.bind(this));
        } else {
            const items = (resp?.data || []).map((it, i, arr) => {
                it.titleStage = this.getTitleStage(it, arr);
                return it;
            }).filter(it => it.status !== "PRE_CREATED");
            this.setState({ items }, this.checkScrollToItem.bind(this));
        }

        this._helper.hideLoading();
    }

    checkScrollToItem() {
        const id = globalThis.invoicesTempScrollId;
        if (!id)
            return;

        const item = this.table?.domNode?.querySelector(".row" + id);
        if (item?.scrollIntoViewIfNeeded)
            item.scrollIntoViewIfNeeded();

        this.openDetailDialog({ id, clientId: this.props.info.id });

        delete globalThis.invoicesTempScrollId;
    }

    beforeRender() {

    }

    printGroup(listInv) {
        this.printShow("client_transactions", {
            clientId: this.props.info.id + "",
            clinicId: this.props.clinicId + "",
            invoicesIds: [...listInv.map(it => it.id + "")]
        });
    }

    cancelGroup() {
        const { checkBoxes } = this.state;
        Object.keys(checkBoxes).forEach(it => {
            checkBoxes[it] = false;
        });

        Object.keys(this.table).forEach(it => {
            if (it.includes("checkBox"))
                this.table[it].value = false;
        });

        this.setState({ checkBoxes });
    }

    expandeForm() {
        this.groupInvoice.style.height = "339px";
        this.groupInvoiceList.style.maxHeight = "176px";
        this.setState({ formExpande: true });
    }

    shrink() {
        this.groupInvoice.style.height = "225px";
        this.groupInvoiceList.style.maxHeight = "64px";
        this.setState({ formExpande: false });
    }

    renderGroupInvoiceForPrint() {
        const { checkBoxes, items, formExpande } = this.state;

        const listInv = [];
        let listInvSum = 0;

        const clinics = this._helper.getClinics();
        const clinic = clinics.find(infoClinic => infoClinic.id === items[0].domainId);

        Object.keys(checkBoxes).forEach(it => {
            if (it.includes("checkBox") && it !== "checkBoxMain" && checkBoxes[it]) {
                const idInv = it.replace("checkBox", "");
                const row = items.find(item => item.id === +idInv);
                const { id, clientId, createdTime, totalSum, doctorId, securedInvoiceItems, discount, treatmentTask } = row;
                const info = this.props.info;
                const { profileNumber, createdTime: dateRegistration, clientBalance, birthday, totalSum: ts, totalPaidSum } = info;
                const fio = this._helper.string.formatFullName(info);
                const doctor = this._helper.string.formatFullName(this.props.getDoctorById(doctorId));

                listInv.push({
                    id,
                    title: `${id}/${clientId} от ${this._helper.date.toStr(new Date(createdTime), "DD.MM.YYYY")}`,
                    totalSum,
                    fio,
                    doctor,
                    profileNumber,
                    dateRegistration,
                    securedInvoiceItems,
                    clientBalance,
                    debt: ts - totalPaidSum,
                    discount,
                    birthday,
                    clinic,
                    treatmentTask
                });
                listInvSum += totalSum;
            }
        });

        return (<div className="pos rel">
            <div ref={el => this.groupInvoice = el} className="groupInvoice pos abs flex col gap16">
                <div className="text blockTitle">{"Работа с группой счетов"}</div>
                <div className="flex flex1 col gap16">
                    <div className="text p2 black3">{this.textGroup}</div>
                    <div ref={el => this.groupInvoiceList = el} className="listInv flex col flex1 scrolling" style={{ maxHeight: "64px" }}>
                        {listInv.map(it => (<div className="flex gap8">
                            <div className="text p1SemiBold">{it.title}</div>
                            <div className="text p1 gray3">{this._helper.number.toSum(it.totalSum)}</div>
                        </div>))}
                    </div>
                    <div className="flex between">
                        <div className="text p2 black3">{`Всего ${listInv.length} счетов на сумму ${this._helper.number.toSum(listInvSum)}`}</div>
                        {listInv.length > 4 ?
                            <div
                                className="text p2 blue3 hand"
                                onClick={formExpande ? this.shrink.bind(this) : this.expandeForm.bind(this)}>
                                {formExpande ? "Свернуть" : "Смотреть все"}
                            </div> : <div></div>}
                    </div>
                    <div className="buttons flex end gap16">
                        <Button
                            label="main.cancel"
                            size="small"
                            type="transparent"
                            onClick={this.cancelGroup.bind(this)}
                        />
                        <Button
                            label={"Печатать"}
                            size="small"
                            onClick={this.printSelectedInvoice.bind(this, listInv)}
                        />
                    </div>
                </div>

            </div>
        </div>);
    }

    renderLeftActions() {
        return <div></div>;
    }

    renderRightActions(showCanceled) {
        return (
            <div className="opener">
                <ToggleSwitch
                    checked={showCanceled}
                    label="invoice.showCanceled"
                    onChange={this.toggleCanceled.bind(this)}
                />
            </div>
        );
    }

    render() {
        const { sort, items, showCanceled, checkBoxes } = this.state;

        const showGroup = Object.keys(checkBoxes).some(it => checkBoxes[it]);

        this.beforeRender();

        return (
            <div className="flex1 flex col gap8">
                <div className="flex centerV between">
                    {this.renderLeftActions()}
                    {this.renderRightActions(showCanceled)}
                </div>
                <div className="flex1 flex">
                    <Table
                        ref={el => this.table = el}
                        map={this.tableMap}
                        items={items}
                        sort={sort}
                        onSortChange={this.onSortChange.bind(this)}
                        rowProps={this.tableRowProps}
                    />
                </div>
                {showGroup && this.renderGroupInvoiceForPrint()}
            </div>
        );
    }
}
